// extracted by mini-css-extract-plugin
export default {"root":"EditLicenceModal_root__y-uc9"};